import React from 'react'
import PropTypes from 'prop-types'
import {Avatar, Button} from 'rambler-ui'
import {getProvidersOptions} from '@rambler-id/oauth'
import Popup from 'components/Popup'
import ProfileItem from 'components/ProfileItem'
import {allowedProviders} from 'components/OauthButtons/providers'
import css from './styles.css'

const providersOptions = getProvidersOptions([
  ...allowedProviders,
  'instagram',
  'apple',
  'google'
])

export default function DetachSocial({
  id,
  oauthAvatar,
  provider,
  displayName,
  onResolve,
  onReject,
  ...props
}) {
  return (
    <Popup
      {...props}
      title="Удалить способ входа?"
      okButton={
        <Button type="primary" onClick={onReject}>
          Отмена
        </Button>
      }
      cancelButton={
        <Button
          type="outline"
          onClick={onResolve}
          data-cerber-id="profile::delete_provider::delete_provider_button">
          Удалить
        </Button>
      }>
      <ProfileItem
        key={id}
        className={css.profileItem}
        contentClassName={css.profileItemContent}
        leftIcon={<Avatar src={oauthAvatar} profileType={provider} />}>
        <div>
          {displayName && <strong>{displayName}</strong>}
          {displayName && <br />}
          {providersOptions[provider].title}
        </div>
      </ProfileItem>
      <div>
        После удаления вы не сможете входить в свои профиль через{' '}
        {providersOptions[provider].title}
      </div>
    </Popup>
  )
}

DetachSocial.propTypes = {
  id: PropTypes.string,
  oauthAvatar: PropTypes.string,
  provider: PropTypes.string,
  displayName: PropTypes.string,
  onResolve: PropTypes.func,
  onReject: PropTypes.func
}
